import React, { useState, useReducer, useRef } from "react";
import { useDispatch } from "react-redux";
import classes from './InviteUserForm.module.css';
import { AutoComplete } from "primereact/autocomplete";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { copyUsersToAnotherDevice, PowerSearchAPI } from "../../Api Methods/Api";

const input2Reducer = (state, action) => {
    if (action.type === 'USER_INPUT') {
        return { value: action.val, isValid: state.value.length > 0 };
    }
    if (action.type === 'INPUT_BLUR') {
        return { value: state.value, isValid: state.value.length > 0 };
    }
    if (action.type === 'INPUT_CLEAR') {
        return { value: action.val, isValid: state.value.length > 0 };
    }
    return { value: '', isValid: false };
}

const CopyUserToAnotherDeviceForm = ({ apiData, submitButtonText, processFunctionParamaters, HandleCloseModal, dispatch, setSuccess }) => {

    const [siteSearchTerm, setSiteSearchTerm] = useState("");
    const [suggestions, setSuggestions] = useState([]);

    const [input2State, dispatchInput2] = useReducer(input2Reducer, { value: '', isValid: null });

    const getSiteKey = () => {
        if (typeof siteSearchTerm === 'object' && siteSearchTerm !== null) {
            return siteSearchTerm.key;
        }
        return siteSearchTerm;
    };

    const search = (event) => {
        const powerSearch = async (query) => {
            const responseData = await PowerSearchAPI(apiData, query, 50, 1, 0, 0, 0, 0, dispatch);
            const suggestedSites = responseData[0].devices;
            setSuggestions(suggestedSites.map(site => ({ key: site.key, tag: site.tag })));
        };
        powerSearch(event.query);
    };

    const itemTemplate = (item) => (
        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
            <span style={{ fontWeight: 600 }}>{item.key}</span>
            {item.tag && <span style={{ color: "#6c757d", fontSize: "13px" }}>{item.tag}</span>}
        </div>
    );

    const onClearHandler = () => {
        setSiteSearchTerm("");
        dispatchInput2({ type: 'INPUT_CLEAR', val: "" });
    };

    const submitHandler = async (event) => {
        event.preventDefault();
        const toUipioid = getSiteKey();
        if (!toUipioid) return;

        const deviceID = processFunctionParamaters.deviceId;
        const userID = processFunctionParamaters.userID;
        const deviceName = input2State.value;

        const response = await copyUsersToAnotherDevice(apiData, deviceID, toUipioid, deviceName, userID, dispatch);
        setSuccess(response.success ? true : false);
        onClearHandler();
        HandleCloseModal(false);
    };

    return (
        <form onSubmit={submitHandler} className={classes["container"]} method="dialog">
            <ul className={classes["inputs-list"]}>
                <li className={classes["input-container"]}>
                    <AutoComplete
                        value={siteSearchTerm}
                        suggestions={suggestions}
                        completeMethod={search}
                        field="key"
                        itemTemplate={itemTemplate}
                        onChange={(e) => setSiteSearchTerm(e.value)}
                        placeholder="Site ID to copy to"
                        appendTo="self"
                        panelStyle={{ zIndex: 11000 }}
                        style={{ width: "100%" }}
                        inputStyle={{ width: "100%" }}
                    />
                    <small style={{ color: "#6c757d" }}>Type a site ID or portal name to search</small>

                    <InputText
                        value={input2State.value}
                        onChange={(e) => dispatchInput2({ type: 'USER_INPUT', val: e.target.value })}
                        onBlur={() => dispatchInput2({ type: 'INPUT_BLUR' })}
                        placeholder="Create a site name for users mobile app"
                        style={{ width: "100%", marginTop: "10px" }}
                    />
                </li>

                <div className={classes["button-container"]}>
                    <Button icon="pi pi-times" type="button" onClick={onClearHandler} label="Clear" severity="secondary" style={{ marginRight: "10px" }} />
                    <Button icon="pi pi-check" type="submit" label={submitButtonText || "Submit"} severity="success" disabled={!getSiteKey()} />
                </div>
            </ul>
        </form>
    );
};

export default CopyUserToAnotherDeviceForm;
